import { EntityError } from '@cime/breeze-client';

export class EntitiesErrors {

    constructor(
        public errors: EntityError[]
    ) {
    }
}
